import { all } from 'redux-saga/effects';

import consultaDocumentosProduzidos from './consultaDocumentosProduzidos/saga';

export default all([consultaDocumentosProduzidos]);
